<template>
  <el-form-item
    :label="item.label"
    :prop="`${item.field}`"
    :hidden="item.options.hidden"
    v-if="item.showed"
    :rules="[
      {
        required: item.required || false,
        message: item.label + '为必填字段',
      },
    ]"
  >
    <el-select
      v-model="$attrs.model[item.field]"
      :placeholder="item.options.placeholder"
      :style="{ width: item.options.width || '100%' }"
      :clearable="item.options.clearable"
      :disabled="item.options.disabled"
    >
      <el-option v-for="op in item.options.valueData" :key="op.label" :label="op.label" :value="op.code"> </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
export default {
  props: {
    item: Object,
  },
};
</script>

<style lang="scss" scoped></style>
